<template>
    <div>
        <AppBarFrame
            :session="loadSession(applicationName)"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :customLanguage="customLanguage"
            @switch-language="switchLanguage"
        />

        <Notification
            :generalExApplicationEx="generalExApplicationEx"
            :environment="environment"
            :notifications="notifications"
            ref="notificationRef"
        />

        <v-dialog
            transition="scale-transition"
            v-model="show"
            persistent
            scrollable
            :max-width="maxWidth"
        >
            <v-card class="mx-auto" :max-width="maxWidth" height="100%">
                <Transaction
                    :menu="{ transactionName: transactionName, selected: true }"
                    :environment="environment"
                    :generalExApplicationEx="generalExApplicationEx"
                    :simpleHeader="true"
                    :showSuccess="success"
                    :inputData="{ userName: inputUserName ? userName : null }"
                    :customLanguage="customLanguage"
                    :allowLanguage="true"
                    :method="method"
                    :applicationName="applicationName"
                    @transaction-process="transactionProcess"
                    @close-dialog="closeDialog"
                    @update-notification="updateNotification"
                    @switch-language="switchLanguage"
                    ref="transactionRef"
                />

                <v-toolbar
                    flat
                    dense
                    v-if="okRegister() || okResetPassword() || okCancel()"
                >
                    <v-spacer v-if="okRegister()"></v-spacer>
                    <a
                        v-if="okRegister()"
                        link
                        color="transparent"
                        elevation="0"
                        @click="goRegister()"
                    >
                        <span class="text-caption text-decoration-underline">
                            {{ registerTitle() }}
                        </span>
                    </a>
                    <v-spacer v-if="okResetPassword()"></v-spacer>
                    <a
                        v-if="okResetPassword()"
                        link
                        color="transparent"
                        elevation="0"
                        @click="goResetPassword()"
                    >
                        <span class="text-caption text-decoration-underline">{{
                            forgotTitle()
                        }}</span>
                    </a>
                    <v-spacer v-if="okCancel()"></v-spacer>
                    <a
                        v-if="okCancel()"
                        link
                        color="transparent"
                        elevation="0"
                        @click="goCancel()"
                    >
                        <span class="text-caption text-decoration-underline">{{
                            cancelTitle()
                        }}</span>
                    </a>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Transaction from "./../transaction/Transaction";
import { environment } from "../../../environment/environment.js";
import AppBarFrame from "./../main/AppBarFrame";
import Notification from "./../main/Notification";
export default {
    name: "Authentication",
    props: [
        "cancel",
        "resetPassword",
        "register",
        "success",
        "operationField",
        "transactionField",
        "maxWidth",
        "registerField",
        "resetPasswordField",
        "inputUserName",
        "root",
        "method",
    ],
    data() {
        return {
            notifications: [],
            show: true,
            dialog: {},
            generalExApplicationEx: {},
            environment: environment,
            applicationName: null,
            userName: null,
            transactionName: null,
            operationSuccess: false,
            operationData: {},
            operationApplication: false,
            customLanguage: null,
            historyNotif: [],
            timeoutNotif: 3000,
        };
    },
    components: {
        Transaction,
        AppBarFrame,
        Notification,
    },
    methods: {
        transactionProcess(getSuccess, getData, getResponse) {
            this.operationSuccess = getSuccess;
            if (getSuccess == true) {
                if (this.success) {
                    this.showDialog({
                        custom: "success",
                        content: this.getTranApiMessages(getResponse, false),
                    });
                }
                this.operationData = getData;
            } else {
                if (this.success) {
                    this.showDialog({
                        custom: "error",
                        content: this.getTranApiMessages(getResponse, true),
                    });
                }
            }
            this.$emit("transaction-process", {
                success: getSuccess,
                data: getData,
                response: getResponse,
                applicationName: this.applicationName,
                operationApplication: this.operationApplication,
            });
        },

        closeDialog() {
            this.$emit("close-dialog", {
                generalExApplicationEx: this.generalExApplicationEx,
                applicationName: this.applicationName,
            });
        },

        showDialog(data) {
            //this.updateNotification(data);
            this.$refs.transactionRef.showDialog(data);
        },

        loadOperation(transactionName) {
            this.transactionName = transactionName;
            if (this.$refs.transactionRef) {
                this.$refs.transactionRef.callTransaction({
                    transactionName: this.transactionName,
                    selected: true,
                });
            }
        },

        loadData() {
            this.apiGetGeneralApplication({
                path: { applicationName: this.applicationName },
            })
                .then((dataRes) => {
                    this.generalExApplicationEx = dataRes.data;
                    if (this.notBlank(this.applicationName)) {
                        if (this.generalExApplicationEx[this.operationField]) {
                            this.operationApplication = true;
                            this.loadOperation(
                                this.generalExApplicationEx[
                                    this.transactionField
                                ]
                            );
                        } else {
                            this.goToMain();
                        }
                    } else {
                        this.loadOperation(
                            this.generalExApplicationEx[this.transactionField]
                        );
                    }
                })
                .catch((errorRes) => {
                    this.clearSession(this.applicationName);
                    this.clearFrameworkSession();
                    if (errorRes.response.status == 403) {
                        this.launch();
                    } else {
                        /*this.showDialog({
              custom: "error",
              content: "Error loading transaction " + errorRes,
            });*/
                        this.goToErrorServiceUnavaliable({});
                    }
                });
        },

        initOperation() {
            this.loadData();
        },

        specificApp() {
            return this.notBlank(this.applicationName);
        },

        goRegister() {
            this.goToRegister(this.applicationName);
        },
        goResetPassword() {
            this.goToResetPassword(this.applicationName);
        },
        goCancel() {
            this.goToLogin(this.applicationName);
        },

        cleanNotifications() {
            this.historyNotif.concat(this.notifications);
            this.notifications = [];
        },

        updateNotification(data) {
            const add = this.formattedNotification(data);
            this.notifications = add;
            /*
      if (Array.isArray(data.content)) {
        data.content.forEach((notif) => {
          this.notifications.push({
            custom: data.custom,
            content: notif,
          });
        });
      } else {
        this.notifications.push(data);
      }
      */
            this.$refs.notificationRef.open();
            setTimeout(() => {
                this.cleanNotifications();
            }, this.timeoutNotif);
            //this.notifications.push(data);
            //this.$refs.notificationRef.open();
        },

        okCancel() {
            return this.cancel;
        },
        okRegister() {
            let validate = this.generalExApplicationEx[this.registerField];
            return this.register && validate;
        },
        okResetPassword() {
            let validate = this.generalExApplicationEx[this.resetPasswordField];
            return this.resetPassword && validate;
        },
        switchLanguage() {
            this.customLanguage = this.changeLanguage(
                this.generalExApplicationEx
            );
        },
        registerTitle() {
            if (this.okRegister()) {
                const authentication =
                    this.generalExApplicationEx.authentication;
                return this.translatedConfig(
                    this.generalExApplicationEx,
                    this.customLanguage,
                    authentication,
                    "registerTitle"
                );
            }
        },
        forgotTitle() {
            if (this.okResetPassword()) {
                const authentication =
                    this.generalExApplicationEx.authentication;
                return this.translatedConfig(
                    this.generalExApplicationEx,
                    this.customLanguage,
                    authentication,
                    "forgotTitle"
                );
            }
        },
        cancelTitle() {
            const authentication = this.generalExApplicationEx.authentication;
            if (this.okCancel() && authentication) {
                return this.translatedConfig(
                    this.generalExApplicationEx,
                    this.customLanguage,
                    authentication,
                    "cancelTitle"
                );
            }
        },

        launch() {
            this.validateFrameworkSession()
                .then(() => {
                    this.applicationName = this.$route.params.applicationName;
                    this.userName = this.$route.params.userName;
                    this.customLanguage = this.currentLanguage();
                    this.$emit("init", {
                        applicationName: this.applicationName,
                    });
                    this.initOperation();
                })
                .catch(() => {
                    this.goToErrorUnauthorized({});
                });
        },
    },
    created() {
        this.launch();
    },
};
</script>

<style>
</style>